export default {
  validate: {
    required: {
      username: "Please Entry Username",
      password: "Please Entry Password",
      captcha: "Please Entry Captcha",
    },
  },
};
